import type { RouteRecordRaw } from 'vue-router';

export const authRoutes: RouteRecordRaw[] = [
  {
    name: 'login',
    path: '/login',
    component: () => import('../pages/LoginPage.vue')
  },
  {
    name: 'resetPassword',
    path: '/reset-password',
    component: () => import('../pages/ResetPasswordPage.vue')
  }
];

export const authMainRoutes: RouteRecordRaw[] = [
  {
    name: 'personalData',
    path: '/personal-data',
    component: () => import('../pages/PersonalDataPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];
